<script>
	export default {
		name: 'ChanceExecuter',
		methods: {
			getChanceHash(length) {
				const self_ = this;
				return self_.$_chncExec_hash(length)
			},
			getChanceInteger(min, max) {
				const self_ = this;
				let result_ = null;
				if(self_.isFalse(min) || self_.isFalse(max)) {
					result_ = self_.chance.integer()
				} else {
					result_ = self_.chance.integer({ min: min, max: max })
				}
				return result_
			},
			getChanceSessionId() {
				const self_ = this;
				return self_.$_chncExec_hash(40)
			},
			getChanceColor() {
				const self_ = this;
				return self_.chance.color()
			},
			getChanceDocumentKey() {
				const self_ = this;
				return self_.$_chncExec_hash(20)
			},
			$_chncExec_hash(length) {
				const self_ = this;
				return self_.chance.hash({ length: length })
			}
		}
	}
</script>	